import axios from "axios";
import { Auth0Client } from "@auth0/auth0-spa-js";
import { CatalogResponse } from "../../types/catalog";
import { apiConfig } from "../../config";

class CatalogClient {
  private auth0Client: Auth0Client;

  constructor(auth0Client: Auth0Client) {
    this.auth0Client = auth0Client;
  }

  private async getAuthHeaders() {
    const token = await this.auth0Client.getTokenSilently();
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async getCatalog(): Promise<CatalogResponse> {
    if (!apiConfig.providerServiceBase) {
      throw new Error(
        "Provider service base URL is not configured. Please set VITE_PROVIDER_SERVICE_BASE environment variable.",
      );
    }

    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${apiConfig.providerServiceBase}/v2/api/catalog`,
      { headers },
    );
    return response.data;
  }
}

export default CatalogClient;
